import { Link } from "react-router-dom";
import type { Film } from "@/types/film";

interface FilmCardProps {
  film: Film;
  className?: string;
}

export default function FilmCard({ film, className = "" }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className={`group block bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={film.poster}
          alt={`${film.title} 封面`}
          title={`${film.title} - 欧美伦理影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md text-[11px] font-medium bg-primary-900/80 text-background-50 backdrop-blur-sm">
          {film.type === "movie" ? "电影" : "电视剧"}
        </span>
        <span className="absolute top-2.5 right-2.5 flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-bold bg-accent-500 text-foreground-950">
          <i className="ri-star-fill text-[10px]"></i>
          {film.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3.5">
        <h3 className="font-heading font-semibold text-[15px] text-foreground-900 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
          {film.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{film.year}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span className="line-clamp-1">{film.region}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span className="line-clamp-1">{film.genres[0]}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2.5">
          {film.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-md text-[11px] bg-secondary-100 text-secondary-800">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}